import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/database';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Check if we're in demo mode (using placeholder credentials)
const isDemoMode = (
  supabaseUrl === 'https://placeholder-project.supabase.co' ||
  supabaseAnonKey === 'placeholder-anon-key' ||
  supabaseUrl?.includes('placeholder') ||
  supabaseAnonKey?.includes('placeholder') ||
  !supabaseUrl ||
  !supabaseAnonKey
);

// Use placeholder values for demo mode to prevent errors
const finalUrl = isDemoMode ? 'https://placeholder-project.supabase.co' : supabaseUrl!;
const finalKey = isDemoMode ? 'placeholder-anon-key' : supabaseAnonKey!;

export const supabase = createClient<Database>(finalUrl, finalKey, {
  auth: {
    autoRefreshToken: !isDemoMode,
    persistSession: !isDemoMode,
    detectSessionInUrl: !isDemoMode
  }
});

// Export demo mode status
export const isSupabaseDemoMode = isDemoMode;

// Helper function to handle Supabase errors
export const handleSupabaseError = <T>(error: any): { success: false; data: T; error: string } => {
  console.error('Supabase error:', error);
  return {
    success: false,
    data: null as any,
    error: error.message || 'An unexpected error occurred'
  };
};

// Helper function for successful responses
export const handleSupabaseSuccess = <T>(data: T, message?: string): { success: true; data: T; message?: string } => {
  return {
    success: true,
    data,
    message
  };
}; 
